import axios from 'axios';
import { CHATBOT_BACKEND_URL, ALI_WEB_APY } from '../Constants';

export const aliWebPay = async(data)=>{
    const params = new URLSearchParams(data).toString();
    const res = await axios.post(`${ALI_WEB_APY}?${params}`);
    return res.data;
}


export const getOrderCountByClient = async(id)=>{
    const res = await axios.get(`${CHATBOT_BACKEND_URL}orders/getOrderCountByClient:${id}`);
    return res.data;
}

